module.exports = __webpack_public_path__ + "img/google.860aef8.svg";